import React from 'react';
import { Button } from 'react-bootstrap';
import '../assets/css/Welcome.css';
import '../assets/css/styles.css'
import cgLogo from '../assets/images/Capgemini_Logo_Color_RGB.svg';
import Meaning from '../components/Meaning';
import Footer from '../components/Footer';

class Welcome extends React.Component {

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    render() {
        return (
            <>
                <div className="home-banner d-flex">
                    <div className="cg-logo">
                        <img src={cgLogo} alt="Capgemini Logo" width="150" />
                    </div>
                    <div className="header-blue-bg d-flex">
                        <h4 className="welcome-h4">WHAT’S THE BIGGEST IMPACT ON YOUR DIGITAL CARBON FOOTPRINT?</h4></div>
                </div>

                <p className="blue-text">
                    Technology continues to revolutionise the way we live – from improving our homes, schools and offices to advancing our

                    healthcare
                    and leisure time. However, with continued advancement there is an environmental cost. Studies indicate that the Technology industry is expected to produce around 14% of
                    &nbsp;<Meaning
                        content='The release of carbon dioxide emissions (or greenhouse gases) into the atmosphere'
                        word='global emissions'
                    />  by 2040, representing an increase of almost four times current levels.
                </p>

                <p className="black-text">
                    At Capgemini, we believe technology and innovation will be key in achieving &nbsp;<Meaning
                        content='The goal that global carbon emissions are counteracted by the absorption of an equivalent amount of carbon emissions from the atmosphere'

                        word='net zero globally'
                    />. However, we recognise that the opportunity for technology to contribute to climate action will be unproductive if its

                    &nbsp;<Meaning
                        content='Energy Intensity is measured by the quantity of energy required per unit output or activity, so that using less energy to produce a product reduces the intensity'
                        word='energy intensity'
                    /> is not minimised and if we do not mitigate its negative
                    &nbsp;<Meaning
                        content='An environmental cost or benefit caused by the production or consumption of a product or service that is not financially incurred or received by that producer (i.e. pollution is a negative environmental externality) '
                        word='environmental externalities'
                    />
                    .
                </p>

                <p className="black-text">
                    &nbsp;<Meaning
                        content="The world's biggest climate summit, COP26 is the 26th United Nations Climate Change Conference of the Parties taking place in Glasgow during the first 2 weeks of November. This global event is the deadline for governments to set out their more ambitious climate change goals following the Paris Agreement signed at COP21 six years ago"
                        word='COP26'
                    /> provides a unique forum for us to reflect not only on where we are today with sustainable technology, and also where we could be tomorrow – giving us a chance to avoid unsustainable habits.
                    We have created a short quiz to test your knowledge regarding the
                    &nbsp;<Meaning
                        content="A term used to describe the release of carbon into the atmosphere, and can also refer to other types of greenhouse gas emissions which are commonly calculated as carbon dioxide equivalents"

                        word='carbon'
                    /> associated with our everyday technology usage.
                </p>

                <div className="d-flex main-button-row">
                    <Button className="main-btn"
                        variant="primary"
                        onClick={() => this.props.startQuiz()}
                    >
                        Test your knowledge
                    </Button>
                </div>
                <Footer />

            </>
        )
    }
}

export default Welcome;